<header>
  <div class="container">
    <btx-site-logo></btx-site-logo>
  </div>
</header>
